// src/data/services.jsx
export const servicesData = {
    sidebarItems: [
        {
            id: "seo",
            name: "SEO",
            icon: "fas fa-search",
            path: "/services/seo",
            imageUrl: "/assets/images/services/seo-main.jpg",
            color: "#34c759",
            subItems: [
                {
                    name: "AI SEO",
                    path: "/services/seo/ai-seo",
                    icon: "fas fa-brain",
                    imageUrl: "/assets/images/services/ai-seo.jpg",
                    color: "#007aff"
                },
                {
                    name: "GEO",
                    path: "/services/seo/geo",
                    icon: "fas fa-globe-americas",
                    imageUrl: "/assets/images/services/geo-seo.jpg",
                    color: "#5856d6"
                },
                {
                    name: "Technical SEO",
                    path: "/services/seo/technical",
                    icon: "fas fa-cogs",
                    imageUrl: "/assets/images/services/technical-seo.jpg",
                    color: "#ff9500"
                },
                {
                    name: "Ecommerce SEO",
                    path: "/services/seo/ecommerce",
                    icon: "fas fa-shopping-cart",
                    imageUrl: "/assets/images/services/ecommerce-seo.jpg",
                    color: "#ff2d55"
                },
                {
                    name: "International SEO",
                    path: "/services/seo/international",
                    icon: "fas fa-globe",
                    imageUrl: "/assets/images/services/international-seo.jpg",
                    color: "#5ac8fa"
                }
            ]
        },
        {
            id: "paid-media",
            name: "Paid Media",
            icon: "fas fa-ad",
            path: "/services/paid-media",
            imageUrl: "/assets/images/services/paid-media.jpg",
            color: "#007aff",
            subItems: [
                {
                    name: "PPC",
                    path: "/services/paid-media/ppc",
                    icon: "fas fa-search-dollar",
                    imageUrl: "/assets/images/services/ppc.jpg",
                    color: "#34c759"
                },
                {
                    name: "Paid Social",
                    path: "/services/paid-media/paid-social",
                    icon: "fas fa-thumbs-up",
                    imageUrl: "/assets/images/services/paid-social.jpg",
                    color: "#ff9500"
                },
                {
                    name: "Programmatic",
                    path: "/services/paid-media/programmatic",
                    icon: "fas fa-robot",
                    imageUrl: "/assets/images/services/programmatic.jpg",
                    color: "#5856d6"
                },
                {
                    name: "Meta Advertising",
                    path: "/services/paid-media/meta-advertising",
                    icon: "fas fa-facebook",
                    imageUrl: "/assets/images/services/meta-ads.jpg",
                    color: "#007aff"
                },
                {
                    name: "PPC Consultancy",
                    path: "/services/paid-media/ppc-consultancy",
                    icon: "fas fa-handshake",
                    imageUrl: "/assets/images/services/ppc-consultancy.jpg",
                    color: "#ffcc00"
                }
            ]
        },
        {
            id: "Branding",
            name: "Branding",
            icon: "fas fa-palette",
            path: "/services/branding",
            imageUrl: "/assets/images/services/experience.jpg",
            color: "#ff2d55",

            subItems: [
                {
                    name: "CRO",
                    path: "/services/branding/cro",
                    icon: "fas fa-chart-line",
                    imageUrl: "/assets/images/services/cro.jpg",
                    color: "#34c759"
                },
                {
                    name: "Video",
                    path: "/services/branding/video",
                    icon: "fas fa-camera",  // Good for international/global
                    imageUrl: "/assets/images/services/video.jpg",
                    color: "#ffcc00"
                },
                {
                    name: "Creative",
                    path: "/services/branding/creative",
                    icon: "fas fa-chart-bar",  // Better for audit/checklist
                    imageUrl: "/assets/images/services/cro.jpg",
                    color: "#34c759"
                },

                {
                    name: "technology",
                    path: "/services/branding/technology",
                    icon: "fas fa-code",  // Better for web design/development
                    imageUrl: "/assets/images/services/video.jpg",
                    color: "#ffcc00"
                },
                {
                    name: "Web Design",
                    path: "/services/branding/webdesign",
                    icon: "fas fa-code",  // Better for web design/development
                    imageUrl: "/assets/images/services/video.jpg",
                    color: "#ffcc00"
                },
                {
                    name: "Mobile Experience",
                    path: "/services/branding/mobiledesign",
                    icon: "fas fa-smartphone",  // Better for web design/development
                    imageUrl: "/assets/images/services/video.jpg",
                    color: "#ffcc00"
                }
            ]
        },
        {
            id: "Strategy",
            name: "Strategy",
            icon: "fas fa-chess",
            path: "/services/strategy",
            imageUrl: "/assets/images/services/strategy.jpg",
            color: "#ff9500",
            subItems: [
                {
                    name: "Audits & Consultancy",
                    path: "/services/strategy/audits-consultancy",
                    icon: "fas fa-clipboard-check",
                    imageUrl: "/assets/images/services/audits.jpg",
                    color: "#34c759"
                },
                {
                    name: "Market Research",
                    path: "/services/strategy/market-research",
                    icon: "fas fa-search",
                    imageUrl: "/assets/images/services/market-research.jpg",
                    color: "#007aff"
                },
                {
                    name: "International Marketing",
                    path: "/services/strategy/international-marketing",
                    icon: "fas fa-plane",
                    imageUrl: "/assets/images/services/international-marketing.jpg",
                    color: "#5ac8fa"
                },
                {
                    id: "data-ai",
                    name: "Data & AI",
                    icon: "fas fa-database",
                    path: "/services/strategy/data-ai",
                    imageUrl: "/assets/images/services/data-ai.jpg",
                    color: "#5856d6",
                }, {
                    name: "Analytics",
                    path: "/services/strategy/analytics",
                    icon: "fas fa-chart-bar",
                    imageUrl: "/assets/images/services/analytics.jpg",
                    color: "#007aff"
                },
                {
                    name: "Tag Management",
                    path: "/services/strategy/tag-management",
                    icon: "fas fa-tags",
                    imageUrl: "/assets/images/services/tag-management.jpg",
                    color: "#ff9500"
                }
            ]
        },


    ],

    servicesOverview: {
        title: "Our Digital Services",
        subtitle: "Complete Digital Solutions",
        description: "At Reachtix, we provide a complete suite of digital marketing services designed to drive growth, enhance visibility, and maximize your return on investment across all digital channels.",
        heroImage: "/assets/images/services/hero-main.jpg",
        stats: [
            {
                number: "5+", label: "Years of Digital Marketing Excellence"
            },
            {
                number: "100+", label: "Successful Client Projects Delivered"
            },
            {
                number: "95%", label: "Client Satisfaction Rate"
            },
            {
                number: "3x", label: "Average ROI for Our Clients"
            }
        ],
        categories: [
            {
                id: "seo",
                name: "SEO Services",
                description: "Improve your organic visibility and drive sustainable traffic growth through comprehensive search engine optimization strategies.",
                icon: "fas fa-search",
                color: "#34c759"
            },
            {
                id: "paid-media",
                name: "Paid Media",
                description: "Launch and optimize performance-driven advertising campaigns across multiple platforms to reach your target audience.",
                icon: "fas fa-ad",
                color: "#007aff"
            },
            {
                id: "data-ai",
                name: "Data & AI",
                description: "Leverage data analytics and artificial intelligence to gain actionable insights and make smarter marketing decisions.",
                icon: "fas fa-database",
                color: "#5856d6"
            },
            {
                id: "strategy",
                name: "Strategy",
                description: "Develop comprehensive digital strategies through market research, media planning, and expert consultancy.",
                icon: "fas fa-chess",
                color: "#ff9500"
            },
            {
                id: "experience",
                name: "Experience",
                description: "Create compelling user experiences through creative design, conversion optimization, and engaging content.",
                icon: "fas fa-palette",
                color: "#ff2d55"
            }
        ]
    },

    seoPage: {
        title: "SEO Services",
        subtitle: "Drive sustainable organic growth and increase visibility with our comprehensive SEO solutions.",
        description: "Our SEO services are designed to improve your search engine rankings, drive qualified traffic, and increase conversions through proven strategies and cutting-edge techniques.",
        heroImage: "/assets/images/services/seo-main.jpg",
        services: [
            {
                title: "AI SEO",
                description: "Leverage artificial intelligence for advanced SEO strategy and implementation",
                icon: "fas fa-brain",
                imageUrl: "/assets/images/services/ai-seo.jpg",
                color: "#007aff",
                features: [
                    "AI-powered keyword research",
                    "Content optimization",
                    "Predictive analytics"
                ]
            },
            {
                title: "Technical SEO",
                description: "Optimize website infrastructure for search engine crawlers",
                icon: "fas fa-cogs",
                imageUrl: "/assets/images/services/technical-seo.jpg",
                color: "#ff9500",
                features: [
                    "Site speed optimization",
                    "Mobile responsiveness",
                    "Structured data"
                ]
            },
            {
                title: "Ecommerce SEO",
                description: "Specialized SEO strategies for online stores",
                icon: "fas fa-shopping-cart",
                imageUrl: "/assets/images/services/ecommerce-seo.jpg",
                color: "#ff2d55",
                features: [
                    "Product page optimization",
                    "Category SEO",
                    "Ecommerce schema"
                ]
            },
            {
                title: "International SEO",
                description: "Expand your reach to global markets",
                icon: "fas fa-globe",
                imageUrl: "/assets/images/services/international-seo.jpg",
                color: "#5ac8fa",
                features: [
                    "Hreflang implementation",
                    "Local keyword research",
                    "International backlinks"
                ]
            },
            {
                title: "GEO SEO",
                description: "Local SEO optimization for geographic targeting",
                icon: "fas fa-map-marker-alt",
                imageUrl: "/assets/images/services/geo-seo.jpg",
                color: "#34c759",
                features: [
                    "Local citations",
                    "Google My Business",
                    "Location-based keywords"
                ]
            }
        ],
        stats: [
            {
                number: "94%", label: "of online experiences begin with search"
            },
            {
                number: "70%", label: "of clicks go to organic results"
            },
            {
                number: "53%", label: "of all website traffic comes from organic search"
            },
            {
                number: "5x", label: "higher conversion rates from SEO leads"
            }
        ]
    },

    getServiceById: function (id) {
        return this.sidebarItems.find(service => service.id === id);
    },

    getSubService: function (categoryId, serviceName) {
        const category = this.getServiceById(categoryId);
        if (category) {
            return category.subItems.find(item =>
                item.name.toLowerCase().replace(/\s+/g, '-') === serviceName.toLowerCase()
            );
        }
        return null;
    },

    getAllServices: function () {
        return this.sidebarItems;
    },

    getServicesWithImages: function () {
        return this.sidebarItems.map(category => ({
            ...category,
            subItems: category.subItems.map(subItem => ({
                ...subItem,
                fullPath: `${category.path
                    }/${subItem.name.toLowerCase().replace(/\s+/g, '-')
                    }`
            }))
        }));
    }
};

export default servicesData;